import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id", "type", "placeholder"]

import IoInputWrapper from '@/components/form/InputWrapper.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Input',
  props: /*#__PURE__*/_mergeModels({
    label: { default: undefined },
    type: { default: 'text' },
    placeholder: { default: undefined }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const modelValue = _useModel<string | number>(__props, "modelValue");



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IoInputWrapper, { label: _ctx.label }, {
    default: _withCtx(({ inputId }) => [
      _withDirectives(_createElementVNode("input", {
        id: inputId,
        type: _ctx.type,
        placeholder: _ctx.placeholder,
        style: {"width":"100%"},
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event))
      }, null, 8, _hoisted_1), [
        [_vModelDynamic, modelValue.value]
      ])
    ]),
    _: 1
  }, 8, ["label"]))
}
}

})